module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap opti_wrap",
    class: {
      pd110: _vm.btnFixed
    },
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    staticClass: "closeBtn",
    attrs: {
      "id": "closeBtn",
      "src": "https://resource.0168.net.cn/activity-mall/h5/theme16/ic-confirm-close.png",
      "onclick": "window.history.go(-1)"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "descDiv",
    attrs: {
      "id": "descDiv"
    }
  }, [_c('div', {
    staticClass: "descTitle",
    attrs: {
      "id": "descTitle"
    }
  }, [_vm._v("活动规则")])]), _vm._v(" "), _c('div', {
    staticClass: "contentText",
    attrs: {
      "id": "contentText"
    }
  }, [_c('p', [_vm._v("1、活动对象：2G/3G/4G/5G手机用户。")]), _vm._v(" "), _c('p', [_vm._v("2、活动内容：活动期间凡首次在本页面成功开通业务（业务资费：6元起/月，具体资费以短信为准）即可每月从腾讯视频VIP、爱奇艺VIP等热门权益中任选一种兑换领取和随机话费红包任性送（仅开通当月享有一次机会）。")]), _vm._v(" "), _c('p', [_vm._v("热门权益（15选1)：腾讯视频VIP月卡、优酷视频黄金会员月卡、爱奇艺黄金会员月卡、芒果TV会员月卡、PP视频会员月卡、哔哩哔哩会员月卡、网易云音乐黑胶会员月卡、QQ音乐绿钻豪华版月卡、酷狗音乐豪华VIP月卡、酷我音乐会员月卡、掌阅VIP月卡、知乎盐选会员月卡、Keep健身会员月卡、喜马拉雅VIP月卡、懒人听书会员月卡。")]), _vm._v(" "), _c('p', [_vm._v("3、礼品发放：")]), _vm._v(" "), _c('p', [_vm._v("（1）热门权益兑换方式：进入"), _c('a', {
    attrs: {
      "href": "https://mf.0168.net.cn/benefit-platform"
    }
  }, [_vm._v("https://mf.0168.net.cn/benefit-platform")]), _vm._v("，登录后，选择您需要的权益进行兑换。")]), _vm._v(" "), _c('p', [_vm._v("（2）话费权益兑换方式：进入"), _c('a', {
    attrs: {
      "href": "https://mf.0168.net.cn/benefit-platform"
    }
  }, [_vm._v("https://mf.0168.net.cn/benefit-platform")]), _vm._v("，登录后，选择话费面值，点击“立即兑换”即可直充到账。")]), _vm._v(" "), _c('p', [_vm._v("温馨提示：使用相关权益时，请遵守相应平台的用户服务协议和权益使用协议，如违反相关协议规定，运营商和联合权益提供方均有权单独进行处理，包括但不限于中止或终止提供其所属平台的服务及要求侵权赔偿等。")]), _vm._v(" "), _c('p', [_vm._v("4、注意事项：")]), _vm._v(" "), _c('p', [_vm._v("（1）每个手机号仅限参与一次，如当月不退订，次月自动续订；")]), _vm._v(" "), _c('p', [_vm._v("（2）本业务退订后视作放弃本活动福利礼品，未充值到账或未兑换的礼品将不再发放（福利礼品包括会员、代金券、话费等）；")]), _vm._v(" "), _c('p', [_vm._v("（3）已开通本业务的老用户不可再次参与本次推广活动。")]), _vm._v(" "), _c('p', [_vm._v("（4）权益领取周期为自然月，热门权益需用户手动领取，如当月热门权益未领取，次月无法补领上月权益，请及时领取。")]), _vm._v(" "), _c('p', [_vm._v("（5）未退订状态下，权益连续下发12个月；如发生退订，则次月起不再发放该权益。")]), _vm._v(" "), _c('p', [_vm._v("（6）此权益兑换活动仅适用于专属互联网渠道订购成功用户。")]), _vm._v(" "), _c('p', [_vm._v("5、退订方式：")]), _vm._v(" "), _c('p', [_vm._v("（1）联通退订方式：进入中国联通APP-服务-我已订购-增值业务-选择相关业务名称-退订，或者发送短信0000至10010，按提示内容退订； ")]), _vm._v(" "), _c('p', [_vm._v("（2）移动退订方式：发送短信0000至10086，按提示内容退订。 ")]), _vm._v(" "), _c('p', [_vm._v("（3）电信退订方式：发送短信00000至10001，按提示内容退订。")]), _vm._v(" "), _c('p', [_vm._v("6、由于产品价格可能出现临时调整，具体资费以实际扣费短信为准。")]), _vm._v(" "), _c('p', [_vm._v("7、如有疑问可致电客服热线："), _c('a', {
    attrs: {
      "href": "tel:4008008663"
    }
  }, [_vm._v("4008008663")]), _vm._v("进行咨询。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px auto"
    },
    attrs: {
      "id": "linkGZH"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgb(0, 0, 81)",
      "font-size": "12px"
    },
    attrs: {
      "href": "https://mf.0168.net.cn/benefit-platform/"
    }
  }, [_vm._v("福利兑换中心")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69bdca4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/h5/themeaqy_activity/ThemeAqyActivity.vue
// module id = 1060
// module chunks = 119